module.exports = __webpack_public_path__ + "img/certification-origin3.ef7e8baf.png";